import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

import { ReactComponent as Checkbox } from '@/assets/icons/checkbox-icon.svg';

export const FormWrapper = styled(Flex)`
  flex-direction: column;
  max-width: 500px;
  margin: 0 auto;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
  `}
`;

export const SuccessIcon = styled(Checkbox)``;
